import { createRouter,createWebHistory  } from 'vue-router'
import BookingPanelMap from '../views/BookingPanelMap.vue'
import BookingCalendar from '../views/BookingCalendar.vue'
import BookingForm from '../views/BookingForm.vue'
import RegistrationResult from '../views/RegistrationResult.vue'

const routes = [
  {
    path: '/',
    name: 'BookingPanelMap',
    component: BookingPanelMap   
  },
  {
    path: '/BookingCalendar',
    name: 'BookingCalendar',
    component: BookingCalendar
  },
  {
    path: '/BookingForm',
    name: 'BookingForm',
    component: BookingForm
  },
  {
    path: '/registrationResponse',
    name: 'RegistrationResponse',
    component: RegistrationResult
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior () {
    return { left: 0, top: 0 }
  }
})

export default router
